import React, { forwardRef } from "react";
import Sidebar from "../sidebar/Sidebar";
import Navbar from "../header/Navbar";
import { getMyGroupList } from "../../services/GroupService";
import { useState } from "react";
import { useEffect } from "react";
import { changeDateFormatYYYY, showToastError } from "../../Utils/Helper";
import CounterChip from "./CounterChip";
import CalanderSvg from "../../svg/DashboardCalander.svg";
import ClientSvg from "../../svg/DashboardMyClients.svg";
import CareplanSvg from "../../svg/DashboardCareplan.svg";
import GroupsSvg from "../../svg/DashboardGroups.svg";
import { getUpcomingBookingsByDate } from "../../services/DoctorService";
import { getCarePLan } from "../../services/PatientService";
import UpcomingSessions from "./UpcomingSessions";
import DashMember from "./Dash_Member";
import DashPrograms from "./Dash_Programs";
import DashGroups from "./Dash_Groups";
import DashTasks from "./Dash_Tasks";
import "./style.css";
import moment from "moment";
import ReactDatePicker from "react-datepicker";
import { RiExpandUpDownFill } from "react-icons/ri";
import { storeQBUser, useAuth } from "../../Context/AuthContext";
import { useSearchParams } from "react-router-dom";
import { getObjectFromStore, storageKeys } from "../../storage/Storage";
import dayjs from "dayjs";
import { getMembers } from "../../services/DashboardService";
import { useDateTimezone } from "../../Context/DateTimezoneContext";

function Index() {
  const auth = useAuth();
  const [params] = useSearchParams();
  const code = params?.get("code");
  const [groupList, setGroupList] = useState([]);
  const [carePlanList, setCarePlanList] = useState([]);
  const [bookingList, setBookingList] = useState([]);
  const [myClientsList, setMyClientsList] = useState({ length: 0 });
  const [isLoading, setLoader] = useState(true);
  const [calFilter, setCalFilter] = useState(new Date());
  const {setDashboardDate} = useDateTimezone();
  useEffect(() => {
    getGroupList();
    getMyClientsList(moment(new Date()).format("YYYY-MM-DD"));
    setDashboardDate(new Date())
    setCalFilter(new Date())
    getCareplanList();
    getMyBookingRequestList(); // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getGroupList();
    getCareplanList();
    getMyBookingRequestList(moment(new Date(calFilter)).format("YYYY-MM-DD"));
    getMyClientsList(moment(new Date(calFilter)).format("YYYY-MM-DD"));
  }, [calFilter]);

  useEffect(() => {
    if (code) {
      auth.addZoomId(code);
    }
  }, [code]);

  useEffect(() => {
    if (auth.getMessageUnreadCount) {
      auth.getMessageUnreadCount();
    }
  });

  useEffect(() => {
    checkStorageUser();
    // !code && checkZoomCodeAdded() // Remove this zoom code status
  }, []);

  const checkStorageUser = () => {
    if (!getObjectFromStore(storageKeys.user)) {
      storeQBUser(auth?.authUser);
    }
  };


  const getGroupList = async () => {
    try {
      // Use Axios to send requests to both APIs concurrently
      const [response1, response2] = await Promise.all([
        getMyGroupList(),
        getMyGroupList("&myassign=true"),
      ]);

      // Check if the requests were successful
      if (response1.status !== 200 || response2.status !== 200) {
        throw new Error("Failed to fetch data");
      }

      // Access the data from the responses
      const result1 = response1.data?.data;
      const result2 = response2.data?.data;

      // Combine and remove duplicates
      const combinedResult = [...result1, ...result2];
      const uniqueResult = Array.from(
        new Set(combinedResult.map((item) => item._id))
      ).map((id) => combinedResult.find((item) => item._id === id));

      // Update state with the unique data
      const nonArchivedResult = uniqueResult
        .filter((item) => !item.isArchive)
        .map((item) => item);
      const dateFiltering = nonArchivedResult
        .filter((item) => dayjs(item.createdAt) <= calFilter)
        .map((item) => item);
      setGroupList(dateFiltering);
      setLoader(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    }
  };

  const getCareplanList = async (searchWord) => {
    setLoader(true);
    try {
      const response = await getCarePLan(searchWord || "");
      if (response?.status === 200) {
        const nonArchivedResult = response?.data?.data
          .filter((item) => !item.isArchive)
          .map((item) => item);
        const dateFiltering = nonArchivedResult.filter(
          (item) => dayjs(item.createdAt) <= calFilter
        );
        setCarePlanList(dateFiltering);
        setLoader(false);
      } else {
        showToastError(`Couldn't Fetch Client List`);
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  const getMyBookingRequestList = async (searchWord) => {
    setLoader(true);
    try {
      const response = await getUpcomingBookingsByDate(
        changeDateFormatYYYY(searchWord || new Date())
      );
      if (response?.status === 200) {
        console.log(response.data.data.length)
        setBookingList(response?.data.data);
        setLoader(false);
      } else {
        showToastError(`Couldn't Fetch Group List`);
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const getMyClientsList = async (date) => {
    setLoader(true);
    try {
      const response = await getMembers(date);
      if (response?.status === 200) {
        setMyClientsList({ length: response.data.totalMembers });
        setLoader(false);
      } else {
        showToastError(`Couldn't Fetch Group List`);
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const DateFilter = forwardRef(({ value, onClick }, ref) => {
    return (
      <button className="btn" onClick={onClick} ref={ref}>
        <span className="fw-bold me-2" style={{ fontSize: "18px" }}>
          {moment(new Date(calFilter)).format("MMM DD YYYY")}
        </span>
        <span>
          <RiExpandUpDownFill />
        </span>
      </button>
    );
  });

  return (
    <>
      <Navbar />
      <div className="container-fluid mb-5">
        <div className="row">
          <div className="col-md-2">
            <Sidebar />
          </div>
          <div className="col-md-10 px-4">
            <header className="py-2">
              <h3 className="py-1 headFont accordion fw-bold">
                Welcome Dr. {JSON.parse(localStorage.getItem("first_name"))}{" "}
                {JSON.parse(localStorage.getItem("last_name"))}
              </h3>
              <p className="py-1 resFont">Have a great day at work</p>
            </header>
              <ReactDatePicker
                dateFormat="MM-dd-yyyy"
                selected={calFilter}
                className="description_inputf mb-0 "
                showMonthDropdown
                showYearDropdown
                yearDropdownItemNumber={300}
                scrollableYearDropdown
                onChange={(date) => {
                  setCalFilter(date);
                  setDashboardDate(date)
                }}
                customInput={<DateFilter />}
                placeholderText="mm-dd-yyyy"
              />
            <div className="d-flex justify-content-evenly py-2 gap-2">
              <CounterChip
                bgcolor="rgba(197, 50, 69, 1)"
                title="Booking Request"
                data={bookingList}
                icon={CalanderSvg}
                link={"/todayappointment"}
              />
              <CounterChip
                bgcolor="rgba(215, 180, 101, 1)"
                title="My Clients"
                data={myClientsList}
                icon={ClientSvg}
                link={"/allpatientlist"}
              />
              <CounterChip
                bgcolor="rgba(116, 169, 193, 1)"
                title="Care plans"
                data={carePlanList}
                icon={CareplanSvg}
                link={"/careplan"}
              />
              <CounterChip
                bgcolor="rgba(165, 167, 168, 1)"
                title="Groups"
                data={groupList}
                icon={GroupsSvg}
                link={"/groups"}
              />
            </div>
            <div className="row mt-4">
              <section className="col-md-6">
                <UpcomingSessions filter={calFilter}  isLoading={isLoading} />
                <DashTasks  isLoading={isLoading} />
              </section>
              <section className="col-md-6">
                <DashMember
                  newMember={"20000"}
                  isLoading={isLoading}
                  totalMember={"30000"}
                />
                <DashPrograms  isLoading={isLoading} />
                <DashGroups
                  groups={groupList}
                  isLoading={isLoading}
                />
                {/* <DashMesaages filter={calFilter} isLoading={isLoading} /> */}
              </section>
            </div>
            <div className="row">
              <section className="col-md-6">
                {/* <DashTasks filter={calFilter} isLoading={isLoading} /> */}
              </section>
              <section className="col-md-6">
                {/* <DashMesaages filter={calFilter} isLoading={isLoading} /> */}
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Index;
